export default __webpack_public_path__ + "static/tooltip-css-1f7be424bc4e24795e404f0ac33b137f.png";